import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || 'a4d7bfa3-6310-4f04-8c50-1269678541e5',
    authority: process.env.REACT_APP_ENTRA_AUTHORITY || 'https://viewsubauth.ciamlogin.com/ba13ef3b-9425-4f0e-b6f8-c6caa3453f5a',
    knownAuthorities: [process.env.REACT_APP_ENTRA_KNOWN_AUTHORITY || 'viewsubauth.ciamlogin.com'],
    redirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || 'https://app.vusub.ai',
    postLogoutRedirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || 'https://app.vusub.ai',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

// Deep-links straight to the Entra External ID sign-up screen (OIDC prompt=create),
// so "Create account" / invite CTAs land on registration instead of the combined
// sign-in page where the create link is easy to miss.
export const signupRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
  prompt: 'create',
};

export const editProfileRequest = {
  authority: process.env.REACT_APP_ENTRA_AUTHORITY || 'https://viewsubauth.ciamlogin.com/ba13ef3b-9425-4f0e-b6f8-c6caa3453f5a',
  scopes: ['openid', 'profile'],
  prompt: 'login',
};

export const msalInstance = new PublicClientApplication(msalConfig);
